import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledEntitiesValidateWizardContent = styled(Box)`
  padding-bottom: 0px;
  
  &.EntitiesValidateWizardContent {
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.layout('2sp')};
    padding-bottom: 0 !important;
  }

  .EntitiesValidateWizardContent {
    &-subtitle {
      display: flex;
      align-items: center;
      gap: ${props => props.theme.layout('2sp')};
      
      .H6 {
        flex-grow: 1;
        color: ${props => props.theme.property('palette.text.secondary')};
      }
      .Form {
        min-width: ${props => props.theme.layout(340)};
        max-width: ${props => props.theme.layout(340)};
      }
    }
    &-table {
      .MuiTableRow-head {
        background-color: ${props => utils.rgba2Rgb(props.theme.property('palette.primary.states.hover'))};
        .TableHeader {
          padding: ${props => props.theme.layout('0.75sp')} ${props => props.theme.layout('1sp')};
          .TableHeaderText {
            line-height: unset;
          }
        }
      }

      .MuiTableContainer-root {
        padding-bottom: ${props => props.theme.spacing(2)};
      }
    }

    &-loader {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: ${props => props.theme.property('zIndex.loader')};
      
      opacity: 0.8;
      background-color: ${props => props.theme.property('palette.background.default')};
    }
  }
    
  ${ComponentStyles}
`;

StyledEntitiesValidateWizardContent.propTypes = {
  theme: PropTypes.object
};

export default StyledEntitiesValidateWizardContent;
